import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await register(form.email, form.password, form.name);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome to the sisterhood.");
      nav("/dashboard");
    } else {
      setErr(res.error);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-screen" data-testid="signup-page">
      <div className="container-aviana max-w-md">
        <p className="overline mb-3">Create your account</p>
        <h1 className="font-serif text-5xl text-aviana-ink">Join the sisterhood.</h1>
        <p className="mt-3 text-aviana-muted">Save retreats, track course progress, and receive moon-cycle letters.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="signup-form">
          <div>
            <label className="overline">Your name</label>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="w-full bg-transparent border-b border-aviana-border focus:border-aviana-gold py-3 outline-none" data-testid="signup-name" />
          </div>
          <div>
            <label className="overline">Email</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="w-full bg-transparent border-b border-aviana-border focus:border-aviana-gold py-3 outline-none" data-testid="signup-email" />
          </div>
          <div>
            <label className="overline">Password</label>
            <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="w-full bg-transparent border-b border-aviana-border focus:border-aviana-gold py-3 outline-none" data-testid="signup-password" />
          </div>
          {err && <p className="text-sm text-red-700" data-testid="signup-error">{err}</p>}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="signup-submit">
            {busy ? "Creating…" : "Create account"}
          </button>
        </form>

        <p className="mt-8 text-sm text-aviana-muted">
          Already a sister? <Link to="/login" className="text-aviana-ink underline underline-offset-4">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
